import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import type {createUserApiResponseType, createUserType, user} from "../../utils/typesConstant/types.tsx";

export const userApiSlice = createApi({
    reducerPath: "userApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_URL || "https://mediassist.tinkernxt.com"}/users/`,
    }),
    tagTypes: ["getUser", "createUser"],
    endpoints: (builder) => ({
        getUsers: builder.query<UsersApiResponse, void>({
            query: () => ({url: "get_user_list/", method: "GET"}),
            providesTags: ["getUser"]
        }),
        userLogin: builder.mutation<void, { username: string; password: string }>({
            query: ({username, password}) => ({
                url: "login/", method: "POST", body: {
                    "username": username, "password": password,
                }
            }),
        }),
        adminLogin: builder.mutation<void, void>({
            query: () => ({url: "/sdv", method: "POST", body: {}}),
        }),
        createUser: builder.mutation<createUserApiResponseType, createUserType>({
            query: (userObject) => ({url: "create_user/", method: "POST", body: userObject}),
            invalidatesTags: ["getUser"]
        }),
        updateUser: builder.mutation<void, user>({
            query: (updatedUserObject) => ({
                url: "update_user/",
                method: "PUT",
                body: updatedUserObject
            }),
            invalidatesTags: ["getUser"]
        }),

    }),
});

type UsersApiResponse = {
    users: user[];
};


export const {
    useGetUsersQuery,
    useUserLoginMutation,
    useAdminLoginMutation,
    useCreateUserMutation,
    useUpdateUserMutation
} = userApiSlice;
